import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import TicketView from "./TicketView";
import { printTicketDoc } from "../lib/ticketPrint";
import { reciboLicenciaDoc } from "../lib/ticketDocs";
import { BadgeCheck, Printer } from "lucide-react";

// Aviso dentro del sistema: recibo de pago de licencia (tarjeta MP o transferencia validada)
export default function PaymentReceiptNotice({ company }) {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/license/receipts?unseen=true").then(({ data: d }) => { if (d.receipts?.length) setData(d); }).catch(() => {}); }, []);
  if (!data) return null;
  const r = data.receipts[0];
  const doc = reciboLicenciaDoc(r, data.license);
  const close = async () => { try { await api.post(`/license/receipts/${r.id}/seen`); } catch { /* noop */ } setData(null); };
  return (
    <Dialog open onOpenChange={(v) => !v && close()}>
      <DialogContent className="max-w-sm max-h-[92vh] flex flex-col" data-testid="payment-receipt-notice">
        <DialogHeader>
          <DialogTitle className="font-display flex items-center gap-2 text-emerald-700"><BadgeCheck size={20} /> ¡Pago recibido!</DialogTitle>
          <DialogDescription>Tu licencia quedó activa hasta el <b>{data.license?.end_date ? new Date(data.license.end_date).toLocaleDateString("es-MX") : "—"}</b>. Aquí está tu recibo.</DialogDescription>
        </DialogHeader>
        <div className="flex justify-center overflow-x-auto flex-1 min-h-0 overflow-y-auto bg-slate-50 rounded-lg py-2"><TicketView doc={doc} company={company || { name: r.business_name }} format="80mm" /></div>
        <div className="flex gap-2">
          <Button variant="outline" className="flex-1" onClick={() => printTicketDoc(doc, company || { name: r.business_name }, "80mm")} data-testid="receipt-print"><Printer size={15} className="mr-1" /> Imprimir</Button>
          <Button className="flex-1 bg-emerald-500 hover:bg-emerald-600 text-white font-bold" onClick={close} data-testid="receipt-ok">Entendido</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
